import { Row, Col, Card, Typography,  Image } from "antd";
import { bucket_url } from "../../../constants/constString";
import DummyImage from "../../../assets/images/dummy-image.png";
import "./CourseCard.style.css";

const { Title, Paragraph } = Typography;

const CourseCardForExam = (props) => {
  const { data } = props;

  return (
    <Card className="course-card" hoverable>
      <Row gutter={16}>
        <Col xs={24}>
          {!!data && !!data?.image ? (
            <Image
              className="card-cover-img"
              alt="example"
              placeholder={true}
              height={240}
              style={{ objectFit: "cover" }}
              src={data?.image ? bucket_url + data?.image : DummyImage}
              fallback={DummyImage}
              width={"100%"}
            />
          ) : (
            <Image
              className="card-cover-img"
              alt="example"
              height={240}
              style={{ objectFit: "cover" }}
              src={DummyImage}
              width={"100%"}
            />
          )}
        </Col>
        <Col xs={24} md={24} lg={24} className="course-info">
          <div
            className="course-card-meta"
            style={{ height: "100%", padding: "10px 20px" }}
          >
            <Title level={3} className="course-title">
              {data?.name || "Title"}
            </Title>
            <Paragraph className="course-card-description">
              {data?.description}
            </Paragraph>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CourseCardForExam;
